import type { ReactNode } from "react";
import { usePet } from "@/hooks/usePets";
import { PrescriptionDraftProvider } from "./PrescriptionDraftContext";
import { PrescriptionDraftPreviewCard } from "./PrescriptionDraftPreviewCard";
import { useDraftContextData } from "./useDraftContextData";

/** Dialog body for callers outside the medical record: editor on the left, real preview on the right (lg+). */
export function PrescriptionDialogLayout({
  petId,
  medicalRecordId = null,
  children,
}: {
  petId: string;
  medicalRecordId?: string | null;
  children: ReactNode;
}) {
  const { data: pet } = usePet(petId);
  const context = useDraftContextData({ pet, medicalRecordId });
  return (
    <PrescriptionDraftProvider context={context}>
      <div className="grid gap-6 lg:grid-cols-[minmax(0,3fr)_minmax(0,2fr)]">
        <div className="min-w-0">{children}</div>
        <PrescriptionDraftPreviewCard className="hidden self-start lg:flex" />
      </div>
    </PrescriptionDraftProvider>
  );
}
